/* eslint-disable curly */
/* eslint-disable max-len */
import DatePickerMixin from '@/mixins/datepicker';
import uuidv4 from 'uuid/v4';
import tableFiltersHelper from './table-filters-helper';

export default {
    name: 'VTableFilters',
    mixins: [DatePickerMixin],
    props: {
        columns: {
            type: Array,
            required: true
        },
        reFilters: {
            type: Array,
            required: false
        },
        section: {
            type: String,
            required: true
        }
    },

    /**
     * @override
     */
    data() {
        return {
            field: null,
            condition: null,
            conditionValue: null,
            errorForm: false,
            filters: [],
            coincidences: [],
            booleanOptions: [{ value: 'true', text: 'Si' }, { value: 'false', text: 'No' }],
            coincidenceSelectable: [],
            coincidencesValues: [],
            searchCoincidences: false,
            datepickerFilter: '',
            operator: undefined,
            operatorsOptions: [
                { value: 'and', text: 'Y' },
                { value: 'or', text: 'O' }
            ],
            distributorsList: [],
            subdistributorsList: []
        };
    },
    /**
     * @override
     */
    mounted() {
        if (this.reFilters && this.reFilters.length > 0) {
            this.filters = this.reFilters;
        }
    },
    methods: {
        selectOperator(item) {
            this.operator = item; // Actualiza el operador seleccionado
            this.onSelectOperator(); // Dispara la lógica asociada
            
        },      
        /**
         * Añadimos un filtro al array y reseteamos el formulario
         * @param {Event} e Evento del form
         */
        onSubmit(e) {
            e.preventDefault();         
            if (!this.validateFilter()) {
                return;
            }
        
            const newFilter = this.createFilter();
            if (this.operator && this.operator.value === 'or') {
                newFilter.orFilter = true;
            }
            this.filters.push(newFilter);
            this.clearForm();
            this.$emit('filter', this.filters);
        },
        
        validateFilter() {
            return this.field && this.condition && (this.conditionValue || this.coincidencesValues);
        },
        
        createFilter() {
            let conditionValue = this.conditionValue;
            if (['eq', 'ne'].includes(this.condition.value)) {
                conditionValue = JSON.stringify(this.coincidencesValues);
            }

            return {
                field: this.field.value,
                condition: this.condition.value,
                conditionValue,
                operator: this.operator
            };
        },
        
        /**
         *
         * @override
         */
        checkForm(e) {
            e.preventDefault();
            if (!this.isFormValid) {
                this.errorForm = true;
                return false;
            }
            this.errorForm = false;
            this.onSubmit(e);
            return true;
        },
        /**
         * Cambiamos el código de la condición a texto
         * @param {String} value Valor del filtro
         * @return {String} Texto de la condición
         */
        conditionToText(value) {
            if (!this.conditions) return;
            const condition = this.conditions.find(c => c.value === value);
            return condition ? condition.text : 'Condición desconocida';
        },
        /**
         * Eliminamos un filtro
         * @param {Number} index Posición del filtro en el array
         */
        removeFilter(index) {
            const filterToRemove = this.filters[index];
            const previousFilter = index > 0 ? this.filters[index - 1] : null;
            // si el filtro que estamos borrando (f2) tiene una clausula 'OR' con el siguiente filtro (orFilter = true)
            // transferimos esa clausula al filtro anterior
            // f1 AND f2 OR f3 = f1 OR f3
            // f1 OR f2 AND f3 = f1 OR f3
            if (filterToRemove.orFilter && previousFilter) {
                previousFilter.orFilter = true;
            }
            // si borramos el último filtro le quitamos el operador 'OR' al filtro anterior ---> f1 OR f2 = f1
            if (index === this.filters.length - 1 && previousFilter && previousFilter.orFilter) {
                previousFilter.orFilter = false;
            }
            this.filters.splice(index, 1);
            const filtered = this.filters.filter(elem => {
                return elem.field === filterToRemove.field;
            });
            if (filtered.length === 1) {
                const idx = this.filters.indexOf(filtered[0]);
                if (this.filters[idx].condition === 'or') {
                    this.filters.splice(idx, 1);
                }
            }
            this.$emit('filter', this.filters);
        },
        /**
         * Limpiamos el formulario
         */
        clearForm() {
            this.errorForm = false;
            this.field = null;
            this.condition = null;
            this.conditionValue = null;
            this.coincidenceSelectable = [];
        },
        clearAllFilters() {
            this.filters.splice(0);
            this.clearForm();
            this.$emit('filter', this.filters);
        },
        /**
         * @override
         */
        onSearchCoincidence(val) {
            if (this.field && this.condition) {
                this.getCoincidenceSelectable(val);
            }
        },
        /**
         * @override
         */
        onSelectCoincidence(val) {
            if (val) {
                if (this.filterOperationRegisteredStatus(this.field, val)) {
                    // Si se filtra por un estado igual a REGISTERED, se cambia la condición a in
                    this.condition.value = this.condition.value === 'eq' ? 'in' : 'nin';
                }
                if (this.fieldIsBoolean(this.field.value) && ['eq', 'ne'].includes(this.condition.value)) {
                    val = val.value;
                }

                // Para distributor/subdistributor, convertir key_name a uuid y usar el campo correcto
                let filterField = this.field.value;
                let filterValue = val;
                let displayValue = null;
                if (this.field.value === 'distributor' && this.distributorsList.length) {
                    const distributor = this.distributorsList.find(d => d.key_name === val);
                    if (distributor) {
                        displayValue = val;
                        filterValue = distributor.uuid_distributor;
                        filterField = this.section === 'interveners' ? 'uuid_distributor_account' : 'uuid_distributor';
                    }
                } else if (this.field.value === 'subdistributor' && this.subdistributorsList.length) {
                    const subdistributor = this.subdistributorsList.find(sd => sd.key_name === val);
                    if (subdistributor) {
                        displayValue = val;
                        filterValue = subdistributor.uuid;
                        filterField = this.section === 'interveners' ? 'uuid_subdistributor_account' : 'uuid_subdistributor';
                    }
                }

                // Si se ha elegido el operador "or" para el filtro nuevo, se pone "orFilter" a true para el filtro anterior
                // de esta manera en el back se crea una query filtro_anterior OR filtro_nuevo
                const hasOrOperator = this.operator && this.operator.value === 'or' || false;
                if (hasOrOperator) {
                    const previousFilter = this.filters[this.filters.length - 1];
                    previousFilter.orFilter = true;
                }
                // Si ya existe un filtro sobre ese campo se le añade al nuevo filtro un uuid como sufijo
                // para que no haya colisiones cuando el array de filtros se transforma en un objeto con los nombres de campos como claves
                const filterAlreadyExists = this.filters.find(filter => filter.field === filterField);
                this.filters.push({
                    field: filterAlreadyExists ? `${filterField}__${uuidv4()}` : filterField,
                    displayField: displayValue ? this.field.value : null,
                    condition: this.condition.value,
                    conditionValue: ['in', 'nin'].includes(this.condition.value)
                        ? filterValue
                        : this.fieldIsDate(this.field.value)
                            ? filterValue
                            : JSON.stringify([filterValue]),
                    displayValue: displayValue
                });
                if (this.fieldIsBoolean(this.field.value) && ['eq', 'ne'].includes(this.condition.value)) {
                    this.clearForm();
                }
                this.$emit('filter', this.filters);
            }
        },
        filterOperationRegisteredStatus(field, val) {
            const isStatusFilter = field.value === 'operation_status';
            return this.section === 'operations' && isStatusFilter && val === 'REGISTERED';
        },
        /**
         * @override
         */
        removeOr(indexOr, indexF) {
            // eslint-disable-next-line prefer-const
            let values = JSON.parse(this.filters[indexF].conditionValue);
            values.splice(indexOr, 1);
            this.filters[indexF].conditionValue = JSON.stringify(values);
            this.$emit('filter', this.filters);
        },
        /**
         * @override
         */
        search(cfg) {
            switch (this.section) {
                case 'issues':
                    return this.$issuesService.getIssues('', cfg);
                case 'users':
                    return this.$usersService.getUsers('', cfg);
                case 'groups':
                    return this.$groupsService.getGroups('', cfg);
                case 'permission_sets':
                    return this.$permissionService.getPermissions('', cfg);
                case 'interveners':
                    cfg.params['$expand'] = 'distributor,subdistributor,videoidentification_status';
                    return this.$intervenersService.getInterveners('', cfg);
                case 'accounts':
                    return this.$accountsService.getAccounts('', cfg);
                case 'operations':
                    return this.$operationsService.getOperations('', cfg);
                default:
                    return null;
            }
        },
        /**
         * @override
         */
        isOrInField(value) {
            try {
                JSON.parse(value);
                return false;
            } catch (err) {
                return true;
            }
        },
        /**
         * Comprueba si el campo es booleano
         * @param {String} field el campo a comprobar
         * @return {Boolean} devuelve si el campo es booleano o no
         */
        fieldIsBoolean(field) {
            return (
                field &&
                (field.lastIndexOf('can_', 0) === 0 ||
                    field.lastIndexOf('has_', 0) === 0 ||
                    field.lastIndexOf('is_', 0) === 0 ||
                    field.lastIndexOf('gdpr_', 0) === 0 ||
                    field.lastIndexOf('data_protection_', 0) === 0
                )

            );
        },
        /**
         * Comprueba si el campo es una fecha
         * @param {String} field el campo a comprobar
         * @return {Boolean} devuelve si el campo es una fecha o no
         */
        fieldIsDate(field) {
            return field && (field.slice(-'date'.length) === 'date' || field.slice(-'_on'.length) === '_on');
        },
        onSelectOperator() {
            if (!this.operator) {
                this.field = null;
                this.condition = null;
            }
        },
        onSelectField() {
            if (this.field && this.fieldIsBoolean(this.field.value)) {
                this.condition = { value: 'eq', text: 'Igual a' };
            } else {
                this.condition = null;
                this.coincidenceSelectable = [];
            }
        },
        onSelectCodition() {
            if (['eq', 'ne'].includes(this.condition.value)) {
                this.getCoincidenceSelectable('');
            }
        }, 
           
        getCoincidenceSelectable(val) {
            this.searchCoincidences = true;

            // Para distributor y subdistributor, cargar opciones desde los servicios dedicados
            if (this.field.value === 'distributor') {
                this.$distributorsService.getDistributors('', { params: { $limit: 9999 } })
                    .then(res => {
                        this.distributorsList = res.data.distributors;
                        this.coincidenceSelectable = this.distributorsList
                            .map(d => d.key_name)
                            .filter(name => !val || name.toLowerCase().includes(val.toLowerCase()))
                            .sort();
                    })
                    .finally(() => (this.searchCoincidences = false));
                return;
            }

            if (this.field.value === 'subdistributor') {
                this.$subdistributorsService.getSubdistributors('', { params: { $limit: 9999 } })
                    .then(res => {
                        this.subdistributorsList = res.data.subdistributors;
                        this.coincidenceSelectable = this.subdistributorsList
                            .map(sd => sd.key_name)
                            .filter(name => !val || name.toLowerCase().includes(val.toLowerCase()))
                            .sort();
                    })
                    .finally(() => (this.searchCoincidences = false));
                return;
            }

            // eslint-disable-next-line prefer-const
            let searchFilters = [
                {
                    field: this.field.value,
                    condition: 'in',
                    conditionValue: val
                }
            ];

            const c = {};
            searchFilters.forEach(f => {
                if (!c[f.field]) {
                    c[f.field] = [];
                }
                const _f = {};
                if (f.conditionValue && typeof f.conditionValue !== 'boolean' && !Date.parse(f.conditionValue)) {
                    f.conditionValue = f.conditionValue.replace(/%/g, '\\%');
                }

                // Ajustar la lógica de búsqueda para condiciones específicas
                if (f.condition === 'in_starts') {
                    _f.in = `${f.conditionValue}%`;
                } else if (f.condition === 'in' || f.condition === 'nin') {
                    _f[f.condition] = `%${f.conditionValue}%`;
                } else if (f.condition === 'eq') {
                    _f[f.condition] = f.conditionValue;
                } else {
                    _f[f.condition] = f.conditionValue;
                }
                c[f.field].push(_f);
            });

            this.searchFilters = c;

            const cfg = {
                params: {
                    $filter: JSON.stringify(this.searchFilters),
                    $distinct: this.field.value
                }
            };

            this.search(cfg)
                .then(res => {
                    const type = Object.keys(res.data)[0];
                    this.coincidenceSelectable = res.data[type].map(usr => `${usr[this.field.value]}`);
                    if (type === 'operations' && this.field.value === 'operation_status') {
                        // Filtrar los distintos estados de Pendiente para dejar solamente uno
                        this.coincidenceSelectable = this.coincidenceSelectable.map(status => {
                            return status.includes('REGISTERED') ? 'REGISTERED' : status;
                        });
                    }
                    this.coincidenceSelectable = [...new Set(this.coincidenceSelectable)];
                })
                .finally(() => (this.searchCoincidences = false));
        },
        
        tryToTranslate(string, field = null) {
            const i18next = this.$i18next;
            if (field && i18next.exists(`filters.${this.section}.${field}.${string}`)) {
                return i18next.t(`filters.${this.section}.${field}.${string}`);
            } else if (
                this.field &&
                i18next.exists(`filters.${this.section}.${this.field.value}.${string}`)
            ) {
                return i18next.t(`filters.${this.section}.${this.field.value}.${string}`);
            } else if (field && i18next.exists(`filters.${this.section}.${field.value}.${string}`)) {
                return i18next.t(`filters.${this.section}.${this.field.value}.${string}`);
            } else if (i18next.exists(`filters.${this.section}.${string}`)) {
                return i18next.t(`filters.${this.section}.${string}`);
            } else {
                return string;
            }
        },

        sanitizeFilterFieldName(fieldName) {
            return fieldName.includes('__') ? fieldName.slice(0, fieldName.lastIndexOf('__')) : fieldName;
        },
        isContentSearchableField() {
            return tableFiltersHelper.contentSearchableFields[this.section].includes(this.field.value);
        },
        isNotComplexField() {
            return tableFiltersHelper.notComplexFields[this.section].includes(this.field.value);
        },
        isNumericField() {
            return tableFiltersHelper.numericComparisionFields[this.section].includes(this.field.value);
        },
        /**
         * Elimina duplicados de las condiciones basado en el campo 'value'.
         * @param {Array} conditions Lista de condiciones.
         * @return {Array} Lista de condiciones sin duplicados.
         */
        removeDuplicateConditions(conditions) {
            const seen = new Set();
            return conditions.filter(condition => {
                if (seen.has(condition.value)) {
                    return false;
                }
                seen.add(condition.value);
                return true;
            });
        }
    },
    computed: {
        columnsAsOptions: {
            /**
             * Cargamos las columnas para poder seleccionar para filtrar
             * @return {Array} Devuelve array de columnas
             */
            get() {
                const colsSelectInput = this.columns
                    .filter(column => column.name[0] !== '_')
                    .filter(column => !column.name.toLowerCase().includes('uuid'))
                    .filter(column => !column.name.toLowerCase().includes('external_code'))
                    .map(column => {
                        return ({
                        text: this.$t(`headers.${column.name}`),
                        value: column.field
                    });
                })
                    .filter(column => !column.text.toLowerCase().includes('headers.'))
                    .filter(column => !column.text.toLowerCase().includes('uuid'))
                    .sort( (a, b) =>  (a.text >= b.text ? 1 : -1) );
                return colsSelectInput;
            }
        },
        conditionsAsOptions: {
            /**
             * Cargamos las condiciones para poder seleccionar para filtrar
             * @return {Array} Devuelve array de condiciones
             */
            get() {
                const conditionsOp = JSON.parse(JSON.stringify(this.conditions));
                return conditionsOp;
            }
        },
        conditions() {
            if (!this.field) return;

            const conditionsDictionary = tableFiltersHelper.conditions;
            let conditions = [...conditionsDictionary.nullConditions];

            if (this.isNotComplexField()) {
                conditions = [...conditions, ...conditionsDictionary.equalityComparisonConditions];
                if (this.isNumericField()) {
                    conditions = [...conditions, ...conditionsDictionary.numericComparisionConditions];
                }
            }
            if (this.isContentSearchableField()) {
                conditions = [ ...conditions, ...conditionsDictionary.contentConditions];
                if (this.isNotComplexField()) {
                    conditions = [ ...conditions, ...conditionsDictionary.startsConditions];
                }
            }

            // Para campos booleanos, solo permitir condiciones de igualdad
            if (this.fieldIsBoolean(this.field.value)) {
                conditions = conditions.filter(cond => ['eq', 'ne'].includes(cond.value));
            }

            // Para campos de fecha
            if (this.fieldIsDate(this.field.value)) {
                conditions = conditions.concat(conditionsDictionary.numericComparisionConditions);
            }
            
            // Eliminar duplicados basados en el campo 'value'
            conditions = this.removeDuplicateConditions(conditions);
            return conditions;
        },
        isFormValid() {
            if (!this.field || !this.condition) return false;
          
            const isNullCondition = ['null', '!null'].includes(this.condition.value);
          
            return isNullCondition || (
              this.conditionValue !== null &&
              this.conditionValue !== '' || 
              this.coincidencesValues.length > 0
            );
        }   
    },
    watch: {
        /**
         * @override
         */
        condition(val) {
            if (['eq', 'ne'].includes(val) && this.field.value === 'photo') {
                setTimeout(this.onSearchCoincidence(':'));
            }
        },
        datepickerFilter(val) {
            this.onSelectCoincidence(this.$moment(new Date(val)).format('YYYY-MM-DD'));
        }
    }
};
